import { bind } from "@react-rxjs/core"
import { map, of, switchMap } from "rxjs"

import { isBuy } from "@/App/Credit/common"
import { Direction } from "@/generated/TradingGateway"
import { getPrice$ } from "@/services/prices"

import { getRfqPayload$ } from "../TileFooter/RfqTimer"

const getPriceByDirection$ = (symbol: string, direction: Direction) =>
  getPrice$(symbol).pipe(
    map(({ bid, ask }) => (isBuy(direction) ? ask : bid)),
    map((price) => ({ isExpired: false, price })),
  )

const [usePrice, getPriceDirection$] = bind(
  (symbol: string, direction: Direction) =>
    getRfqPayload$(symbol).pipe(
      switchMap((payload) =>
        payload
          ? of({
              ...payload,
              price: isBuy(direction)
                ? payload.rfqResponse.price.ask
                : payload.rfqResponse.price.bid,
            })
          : getPriceByDirection$(symbol, direction),
      ),
    ),
)

export { usePrice }

export const priceButton$ = (direction: Direction) => (symbol: string) =>
  getPriceDirection$(symbol, direction)
